import { Inject, Injectable } from '@angular/core';
import { TgBot, InitDataUnsafe, WebAppUser } from '../models/models';

@Injectable({
    providedIn: 'root',
})
export class WebAppService {
    private _initData!: string;
    private _initDataUnsafe!: InitDataUnsafe;

    constructor(
        @Inject('TGBOT')
        private bot: TgBot
    ) {
        if (this.bot.WebApp.initDataUnsafe?.user) {
            this._initData = this.bot.WebApp.initData;
            this._initDataUnsafe = this.bot.WebApp.initDataUnsafe;
        } else if ('locationHash' in window) {
            const webAppInitData = decodeURIComponent((window['locationHash'] as string)
                    .replace(/^#/, '')
                    .replace(/(\&(tgWebAppVersion|tgWebAppPlatform|tgWebAppThemeParams).+)/, '')
                    .replace('tgWebAppData=', ''));
            const webAppInitDataUnsafe: any = this.bot.Utils.urlParseHashParams(webAppInitData)||{};
            for (var key in webAppInitDataUnsafe) {
                var val = webAppInitDataUnsafe[key];
                try {
                    if (val.substr(0, 1) == '{' && val.substr(-1) == '}' ||
                        val.substr(0, 1) == '[' && val.substr(-1) == ']') {
                        webAppInitDataUnsafe[key] = JSON.parse(val);
                    }
                } catch (e) {}
            }
            this._initData = webAppInitData;
            this._initDataUnsafe = webAppInitDataUnsafe;
        }
    }

    get initData(): string {
        return this._initData||'';
    }

    get initDataUnsafe(): InitDataUnsafe {
        return this._initDataUnsafe||{};
    }

    get user(): WebAppUser {
        return this.initDataUnsafe.user||{};
    }

    get platform(): string {
        return this.bot.WebApp.platform;
    }

    get version(): string {
        return this.bot.WebApp.version;
    }

    get platformVersion(): string {
        return this.platform + ':' + this.version;
    }
}

